import AssessmentIcon from "@material-ui/icons/Assessment";
import BarChartIcon from "@material-ui/icons/BarChart";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ConstantList, { PAYMENT_METHOD_LIMITS } from "./appConfig";
import IconWaitingPatient from "./common/Icon/Boarding/IconWaitingPatient";
import IconConcept from "./common/Icon/IconConcept";
import IconHealthCareService from "./common/Icon/IconHealthCareService";
import IconHospitalBed from "./common/Icon/IconHospitalBed";

import IconInsurancePaymentTypeRate from "./common/Icon/IconInsurancePaymentTypeRate";
import IconLocation from "./common/Icon/IconLocation";
import IconPayment from "./common/Icon/IconPayment";
import IconSchedule from "./common/Icon/IconSchedule";
import IconServiceType from "./common/Icon/IconServiceType";
import IconStaff from "./common/Icon/IconStaff";
import IconUserAccount from "./common/Icon/IconUserAccount";
import IconUserEdit from "./common/Icon/IconUserEdit";
import IconVat from "./common/Icon/IconVat";
import IconDrug from "./common/Icon/Store/IconDrug";
import IconMedicalEquipment from "./common/Icon/Store/IconMedicalEquipment";
import IconMedicalSupplies from "./common/Icon/Store/IconMedicalSupplies";
import IconMedicalSupply from "./common/Icon/Store/IconMedicalSupply";
import {
  HIS_ACCOUNTANT,
  HIS_ADMIN,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_CHIEF_TECHNICIAN,
  HIS_DOCTOR,
  HIS_READ_ONLY,
  HIS_SALES_CONSULTANT,
  HIS_SUPER_ADMIN,
  HIS_TEAM_LEAD,
  HIS_TECHNICIAN,
  HIS_TOUR_RECONCILIATION,
  PathModule,
} from "./common/LocalConst";
// import IconReception from "./common/Icon/Module/IconReception";
import {
  AccountBalanceWallet,
  AssignmentInd,
  AssignmentLate,
  AssignmentTurnedIn,
  ConfirmationNumber,
  Dialpad,
  GroupAdd,
  HourglassEmpty,
  List,
  ListAltOutlined,
  MoneyOffOutlined,
  Timer,
} from "@material-ui/icons";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import EventNoteIcon from "@material-ui/icons/EventNote";
import GroupIcon from "@material-ui/icons/Group";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import SettingsIcon from "@material-ui/icons/Settings";
import IconCountry from "./common/Icon/IconCountry";
import IconEthnics from "./common/Icon/IconEthnics";
import IconMapMoney from "./common/Icon/IconMapMoney";
import IconProfession from "./common/Icon/IconProfession";
import IconServiceRequestSet from "./common/Icon/IconServiceRequestSet";

// Helper to check if payment method limits are active
const hasPaymentMethodLimits =
  Array.isArray(PAYMENT_METHOD_LIMITS) && PAYMENT_METHOD_LIMITS.length > 0;

const hasPaymentMethodLimitsJson = JSON.stringify(hasPaymentMethodLimits);
//console.log(hasPaymentMethodLimitsJson);

export const NAVIGATION = [
  {
    name: "module.patientManagement",
    path: PathModule.PATIENT_MANAGEMENT,
    auth: [
      HIS_ADMIN,
      HIS_SALES_CONSULTANT,
      HIS_CASHIER,
      HIS_BRANCH_MANAGER,
      HIS_DOCTOR,
      HIS_CHIEF_TECHNICIAN,
      HIS_TECHNICIAN,
      HIS_READ_ONLY,
    ],
    navigation: [
      {
        name: "Danh sách check in khách hàng",
        path: "check-in-list",
        isVisible: true,
        Icon: IconServiceType,
        auth: [
          HIS_ADMIN,
          HIS_SALES_CONSULTANT,
          HIS_BRANCH_MANAGER,
          HIS_DOCTOR,
          HIS_CASHIER,
          HIS_READ_ONLY,
        ],
      },
      // {
      //   name: "Danh sách khách hàng",
      //   path: "patient-list",
      //   isVisible: true,
      //   Icon: ListAltOutlined,
      //   auth: [
      //     HIS_ADMIN,
      //     HIS_BRANCH_MANAGER,
      //     HIS_CASHIER,
      //     // HIS_SALES_CONSULTANT,
      //     HIS_READ_ONLY,
      //   ],
      // },

      {
        name: "Danh sách lịch hẹn",
        path: "appointment-list",
        isVisible: true,
        Icon: IconInsurancePaymentTypeRate,
        auth: [
          HIS_ADMIN,
          HIS_SALES_CONSULTANT,
          HIS_BRANCH_MANAGER,
          HIS_CASHIER,
          HIS_READ_ONLY,
        ],
      },
      // {
      //   name: "Đặt lịch",
      //   path: "appointment-tracking",
      //   isVisible: true,
      //   Icon: StyleIcon,
      //   auth: [
      //     HIS_ADMIN,
      //     HIS_SALES_CONSULTANT,
      //     HIS_BRANCH_MANAGER,
      //     HIS_READ_ONLY,
      //   ],
      // },
      // {
      //   name: "Quản lý liệu trình khách hàng",
      //   path: "treament-plan-card-list",
      //   isVisible: true,
      //   Icon: IconCalendar,
      //   auth: [HIS_ADMIN, HIS_SUPER_ADMIN, HIS_BRANCH_MANAGER],
      // },
      {
        name: "Quản lý sử dụng thẻ trả trước",
        path: "prepaid-card-usage",
        isVisible: true,
        Icon: CreditCardIcon,
        auth: [
          HIS_ADMIN,
          HIS_SUPER_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_CASHIER,
          HIS_SALES_CONSULTANT,
          HIS_READ_ONLY,
        ],
      },
      // {
      //   name: "Quản lý tích điểm",
      //   path: "reward-point",
      //   isVisible: true,
      //   Icon: ControlPointDuplicateIcon,
      //   auth: [HIS_ADMIN, HIS_SUPER_ADMIN, HIS_BRANCH_MANAGER],
      // },
      // {
      //   name: "Quản lý KH trùng SĐT",
      //   path: "patient-duplicate-phone",
      //   isVisible: true,
      //   Icon: PhoneAndroid,
      //   auth: [
      //     HIS_ADMIN,
      //     HIS_SUPER_ADMIN,
      //     HIS_BRANCH_MANAGER,
      //     HIS_SALES_CONSULTANT,
      //     HIS_CASHIER,
      //   ],
      // },
      {
        name: "Quản lý thu chi",
        path: "voucher-list",
        isVisible: !hasPaymentMethodLimits,
        Icon: MoneyOffOutlined,
        auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_READ_ONLY],
      },
      {
        name: "Báo cáo",
        isVisible: true,
        Icon: IconWaitingPatient,
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_CASHIER,
          HIS_CHIEF_TECHNICIAN,
          HIS_DOCTOR,
          HIS_SUPER_ADMIN,
          HIS_TECHNICIAN,
          HIS_READ_ONLY,
          HIS_ACCOUNTANT,
          HIS_SALES_CONSULTANT,
        ],
        children: [
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo thu chi theo HTTT",
            path: "report-by-payment-method",
            isVisible: true,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
              HIS_TEAM_LEAD,
            ],
            name: "Báo cáo phân bổ doanh thu theo nhân viên (tổng quát)",
            path: "report-employee-revenue-allocation-summary",
            isVisible: !hasPaymentMethodLimits,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo doanh thu chi tiết (nguồn)",
            path: "report-get-revenue-detail",
            isVisible: !hasPaymentMethodLimits,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_SUPER_ADMIN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo doanh thu theo nhóm dịch vụ",
            path: "report-get-group-service",
            isVisible: true,
          },
          {
            auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
            name: "Báo cáo khoản chi cơ sở",
            path: "report-expense",
            isVisible: true,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SALES_CONSULTANT,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
              HIS_TEAM_LEAD,
            ],
            name: "Báo cáo phân bổ doanh thu theo nhân viên",
            path: "report-sales-allocation",
            isVisible: !hasPaymentMethodLimits,
          },
          // {
          //   auth: [
          //     HIS_ADMIN,
          //     HIS_BRANCH_MANAGER,
          //     HIS_CHIEF_TECHNICIAN,
          //     HIS_TECHNICIAN,
          //     HIS_CASHIER,
          //   ],
          //   name: "Báo cáo phân bổ doanh số theo nhân viên",
          //   path: "report-revenue-allocation",
          //   isVisible: true,
          // },
          // {
          //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
          //   name: "Báo cáo công nợ",
          //   path: "report-debt",
          //   isVisible: true,
          // },
          // {
          //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
          //   name: "Báo cáo doanh thu cũ mới",
          //   path: "voucher-item-report",
          //   isVisible: true,
          // },
          // {
          //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
          //   name: "Báo cáo CheckIn",
          //   path: "report-checkin",
          //   isVisible: true,
          // },
          {
            name: "Báo cáo điều trị",
            path: "treatment-report",
            isVisible: !hasPaymentMethodLimits,
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SALES_CONSULTANT,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
          },
          // {
          //   auth: [
          //     HIS_ADMIN,
          //     HIS_BRANCH_MANAGER,
          //     HIS_CHIEF_TECHNICIAN,
          //     HIS_TECHNICIAN,
          //     HIS_CASHIER,
          //   ],
          //   name: "Báo cáo doanh số",
          //   path: "sales-report",
          //   Icon: ListAltOutlined,
          //   isVisible: true,
          // },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo doanh thu chi tiết (cũ/mới)",
            path: "revenue-details-report",
            Icon: ListAltOutlined,
            isVisible: true,
          },
          {
            auth: [
              HIS_SUPER_ADMIN,
              HIS_ADMIN,
              HIS_CASHIER,
              HIS_ACCOUNTANT,
              HIS_BRANCH_MANAGER,
              HIS_READ_ONLY,
            ],
            name: "Báo cáo đăng kí dịch vụ",
            path: "revenue-register-service",
            Icon: ListAltOutlined,
            isVisible: true,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo đăng kí sản phẩm",
            path: "revenue-register-product",
            Icon: ListAltOutlined,
            isVisible: !hasPaymentMethodLimits,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo đăng kí thẻ trả trước",
            path: "revenue-register-card",
            Icon: ListAltOutlined,
            isVisible: !hasPaymentMethodLimits,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo đơn hàng tổng hợp",
            path: "report-order-summary",
            Icon: ListAltOutlined,
            isVisible: !hasPaymentMethodLimits,
          },
          {
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_CHIEF_TECHNICIAN,
              HIS_DOCTOR,
              HIS_SUPER_ADMIN,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
              HIS_ACCOUNTANT,
            ],
            name: "Báo cáo hủy hóa đơn",
            path: "invoice-cancellation-report",
            Icon: ListAltOutlined,
            isVisible: !hasPaymentMethodLimits,
          },
          {
            auth: [
              HIS_SALES_CONSULTANT,
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CHIEF_TECHNICIAN,
              HIS_SUPER_ADMIN,
              HIS_DOCTOR,
              HIS_TECHNICIAN,
              HIS_CASHIER,
              HIS_READ_ONLY,
            ],
            name: "Báo cáo giá bán dịch vụ/sản phẩm/thẻ hiện thời",
            path: "price-item-report",
            Icon: ListAltOutlined,
            isVisible: !hasPaymentMethodLimits,
          },

          {
            auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
            name: "Báo cáo công nợ",
            path: "invoice-item-debt",
            Icon: ListAltOutlined,
            isVisible: true,
          },

          {
            auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
            name: "Báo cáo trừ tiền thẻ cọc",
            path: "deduction-report",
            Icon: ListAltOutlined,
            isVisible: true,
          },
        ],
      },
    ],
  },

  {
    name: "module.treatmentManagement",
    path: PathModule.TREATMENT_MANAGEMENT,
    auth: [
      HIS_ADMIN,
      HIS_BRANCH_MANAGER,
      HIS_DOCTOR,
      HIS_CHIEF_TECHNICIAN,
      HIS_TECHNICIAN,
      HIS_READ_ONLY,
    ],
    navigation: [
      {
        name: "Danh sách điều trị",
        path: "treatment-list-all",
        isVisible: true,
        Icon: ListAltOutlined,
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_DOCTOR,
          HIS_CHIEF_TECHNICIAN,
          HIS_TECHNICIAN,
          HIS_CASHIER,
          HIS_READ_ONLY,
        ],
      },
      {
        name: "Danh sách điều trị theo trạng thái",
        path: "treatment-list",
        isVisible: true,
        Icon: ListAltOutlined,
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_DOCTOR,
          HIS_CHIEF_TECHNICIAN,
          HIS_TECHNICIAN,
          HIS_CASHIER,
          HIS_READ_ONLY,
        ],
      },

      // {
      //   name: "Tiếp nhận điều trị",
      //   path: "receive-treatment",
      //   isVisible: true,
      //   Icon: HowToRegIcon,
      //   auth: [
      //     HIS_ADMIN,
      //     HIS_BRANCH_MANAGER,
      //     HIS_DOCTOR,
      //     HIS_CHIEF_TECHNICIAN,
      //     HIS_TECHNICIAN,
      //   ],
      // },

      {
        name: "Danh sách lịch hẹn",
        path: "treatment-list-appointment",
        isVisible: true,
        Icon: EventNoteIcon,
      },
      // {
      //   name: "Đặt lịch",
      //   path: "appointment-tracking",
      //   isVisible: true,
      //   Icon: StyleIcon,
      //   auth: [
      //     HIS_ADMIN,
      //     HIS_SALES_CONSULTANT,
      //     HIS_BRANCH_MANAGER,
      //     HIS_READ_ONLY,
      //     HIS_CHIEF_TECHNICIAN,
      //     HIS_TECHNICIAN,
      //   ],
      // },

      {
        name: "Báo cáo",
        isVisible: true,
        Icon: IconWaitingPatient,
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_CHIEF_TECHNICIAN,
          HIS_TECHNICIAN,
          HIS_READ_ONLY,
          HIS_DOCTOR,
        ],
        children: [
          // {
          //   name: "Báo cáo dịch vụ chưa thực hiện",
          //   path: "uncompleted-register-services-report",
          //   isVisible: true,
          //   auth: [
          //     HIS_ADMIN,
          //     HIS_BRANCH_MANAGER,
          //     HIS_CHIEF_TECHNICIAN,
          //     HIS_READ_ONLY,
          //   ],
          // },

          {
            name: "Báo cáo thiết bị sử dụng",
            path: "medical-equipment-usage-report",
            isVisible: true,
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CHIEF_TECHNICIAN,
              HIS_SUPER_ADMIN,
              HIS_DOCTOR,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
            ],
          },
          {
            name: "Báo cáo điều trị",
            path: "treatment-report",
            isVisible: true,
            auth: [
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CHIEF_TECHNICIAN,
              HIS_SUPER_ADMIN,
              HIS_DOCTOR,
              HIS_SALES_CONSULTANT,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
            ],
          },
          {
            auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
            name: "Tổng hợp nguyên vật liệu sử dụng",
            path: "construction-materials-synthesis",
            isVisible: true,
          },
          {
            name: "Báo cáo phân bổ doanh thu theo nhân viên",
            path: "report-treament-sales-allocation",
            isVisible: true,
            auth: [
              HIS_DOCTOR,
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CHIEF_TECHNICIAN,
              HIS_SUPER_ADMIN,
              HIS_SALES_CONSULTANT,
              HIS_TECHNICIAN,
              HIS_READ_ONLY,
            ],
          },
          // {
          //   name: "Báo cáo phân bổ doanh số theo nhân viên",
          //   path: "report-treament-revenue-allocation",
          //   isVisible: true,
          //   auth: [
          //     HIS_ADMIN,
          //     HIS_BRANCH_MANAGER,
          //     HIS_CHIEF_TECHNICIAN,
          //     HIS_SUPER_ADMIN,
          //     HIS_DOCTOR,
          //     HIS_SALES_CONSULTANT,
          //     HIS_TECHNICIAN,
          //     HIS_READ_ONLY,
          //   ],
          // },
          {
            name: "Báo cáo tiền tour",
            path: "report-treament-monney-tour",
            isVisible: true,
            auth: [
              HIS_DOCTOR,
              HIS_TECHNICIAN,
              HIS_CHIEF_TECHNICIAN,
              HIS_ADMIN,
              HIS_BRANCH_MANAGER,
              HIS_CASHIER,
              HIS_ACCOUNTANT,
            ],
          },
          {
            name: "Báo cáo giá bán dịch vụ/sản phẩm/thẻ hiện thời",
            auth: [
              HIS_ADMIN,
              HIS_DOCTOR,
              HIS_BRANCH_MANAGER,
              HIS_TECHNICIAN,
              HIS_CHIEF_TECHNICIAN,
              HIS_READ_ONLY,
            ],
            path: "price-item-report",
            Icon: ListAltOutlined,
            isVisible: !hasPaymentMethodLimits,
          },
        ],
      },
    ],
  },

  {
    name: "Xét nghiệm",
    path: PathModule.SUBCLINICAL,
    navigation: [
      {
        name: "Danh sách chờ lấy mẫu",
        path: "sample-code-new",
        isVisible: true,
        Icon: HourglassEmpty,
      },
      {
        name: "Danh sách đã lấy mẫu",
        path: "sample-code-sampled",
        isVisible: true,
        Icon: AssignmentTurnedIn,
      },
      {
        name: "Danh sách đã thực hiện",
        path: "sample-code-processing",
        isVisible: true,
        Icon: Dialpad,
      },
      {
        name: "DS BN xét nghiệm",
        path: "view-list-ladtest",
        isVisible: true,
        Icon: List,
      },

      {
        name: "Quản lý chỉ định xét nghiệm",
        isVisible: true,
        Icon: IconWaitingPatient,
        path: "manage-service-by-group",
      },
    ],
  },
  {
    name: "Chẩn đoán hình ảnh",
    path: PathModule.IMGSTUDY,
    navigation: [
      {
        name: "DS chờ thực hiện",
        path: "view-list-waitting",
        isVisible: true,
        Icon: HourglassEmpty,
      },
      {
        name: "DS đã thực hiện",
        path: "view-list-process",
        isVisible: true,
        Icon: EventAvailableIcon,
      },
    ],
  },
  {
    name: "module.surgeryProcedure",
    path: PathModule.SURGERY_PROCEDURE,
    navigation: [
      {
        name: "DS phẫu thuật",
        path: "surgery-patient-list",
        isVisible: true,
        Icon: IconServiceType,
      },
      {
        name: "DS thủ thuật",
        path: "procedure-patient-list",
        isVisible: true,
        Icon: IconServiceType,
      },
    ],
  },
  {
    name: "module.operatingRoomManagement",
    path: PathModule.SURGERY,
    navigation: [
      {
        name: "Quản lý lịch mổ",
        Icon: IconSchedule,
        isVisible: true,
        children: [
          {
            name: "Danh sách lịch mổ",
            path: "surgery-schedule",
            isVisible: true,
          },
          {
            name: "Xem lịch mổ",
            path: "surgery-schedule-view",
            isVisible: true,
          },
        ],
      },
      {
        name: "Quản lý yêu cầu mổ",
        path: "surgery-request",
        isVisible: true,
        Icon: AssignmentLate,
      },
      {
        name: "Quản lý bệnh nhân ",
        path: "surgery-patient",
        isVisible: true,
        Icon: IconServiceType,
      },
      // {
      //   name: "Quản lý chi phí phòng mổ ",
      //   path: "surgery-fee",
      //   isVisible: true,
      //   Icon: Receipt,
      // },
      // {
      //   name: "Quản lý phòng mổ (bàn mổ) ",
      //   path: "operating-room-table",
      //   isVisible: true,
      //   Icon: TableChart,
      // },
      {
        name: "Quản lý đối tác",
        path: "organization",
        isVisible: true,
        Icon: AssignmentInd,
      },
      {
        name: "Quản lý nhân sự",
        path: "surgery-room-staff",
        isVisible: true,
        Icon: AssignmentInd,
      },
      {
        name: "Quản lý danh mục",
        isVisible: true,
        Icon: IconServiceType,
        children: [
          {
            name: "Danh mục phòng mổ",
            path: "surgery-room",
            isVisible: true,
          },
          {
            name: "Danh mục loại phòng mổ",
            path: "surgery-room-type",
            isVisible: true,
          },
          {
            name: "Danh mục dịch vụ mổ",
            path: "surgery-service",
            isVisible: true,
          },
        ],
      },
    ],
  },
  {
    name: "Phòng tài chính",
    path: PathModule.FEE,
    navigation: [
      {
        name: "Thu viện phí",
        path: "hospital-fee",
        isVisible: true,
        Icon: AccountBalanceWallet,
      },
      {
        name: "Thu tiền nhà thuốc",
        path: "hospital-fee-prescription",
        isVisible: true,
        Icon: AccountBalanceWallet,
      },

      {
        name: "Danh sách hóa đơn",
        path: "voucher-list",
        isVisible: true,
        Icon: IconPayment,
      },

      {
        name: "Theo dõi công nợ",
        path: "voucher-payment-method",
        Icon: IconPayment,
        isVisible: true,
      },
      {
        name: "Báo cáo công nợ theo nguồn",
        path: "report-debit-by-source",
        isVisible: true,
        Icon: PersonOutlineOutlinedIcon,
      },
      {
        name: "Báo cáo thu chi",
        path: "income-expenditure",
        isVisible: true,
        Icon: PersonOutlineOutlinedIcon,
      },
    ],
  },
  {
    name: "Quản trị",
    path: PathModule.MANAGEMENT,
    auth: ["HIS_ADMIN", "HIS_HR_MANAGEMENT", "HIS_SUPER_ADMIN", "HIS_DOCTOR"],
    navigation: [
      {
        name: "Quốc gia",
        path: "country",
        isVisible: true,
        Icon: IconCountry,
      },
      {
        name: "Đơn vị hành chính",
        path: "administrative-unit",
        isVisible: true,
        Icon: IconUserEdit,
      },
      {
        name: "Tổ chức",
        isVisible: true,
        Icon: IconMedicalSupply,
        auth: [
          "HIS_ADMIN",
          "HIS_HR_MANAGEMENT",
          "HIS_SUPER_ADMIN",
          "HIS_DOCTOR",
        ],

        children: [
          {
            name: "Khu Vực",
            path: "emr-organization",
            isVisible: true,
            Icon: IconLocation,
          },
          {
            name: "Cơ sở (chi nhánh)",
            path: "department",
            isVisible: true,
            auth: ["HIS_ADMIN", "HIS_HR_MANAGEMENT"],
          },
          {
            name: "Phòng",
            path: "health-care-room",
            isVisible: true,
          },
          {
            name: "Giường",
            path: "hospital-bed",
            isVisible: true,
          },
        ],
      },
      {
        name: "Dịch vụ/gói dịch vụ/thẻ trả trước",
        isVisible: true,
        Icon: IconHealthCareService,
        children: [
          {
            name: "Loại dịch vụ",
            path: "service-type",
            isVisible: true,
          },
          {
            name: "Nhóm dịch vụ (liệu trình)",
            path: "service-group",
            isVisible: true,
          },
          {
            name: "Dịch vụ",
            path: "health-care-service",
            isVisible: true,
          },
          // {
          //   name: "Thẻ trả trước / Thẻ liệu trình",
          //   path: "service-request-set",
          //   isVisible: true,
          // },
          {
            name: "Thẻ trả trước / Thẻ liệu trình",
            path: "client-card",
            isVisible: true,
          },
          // {
          //   name: "Vai trò trong DV",
          //   path: "service-role",
          //   isVisible: true,
          // },
        ],
      },
      {
        name: "Thông tin khách hàng",
        isVisible: true,
        Icon: IconUserAccount,
        children: [
          // {
          //   name: "Nguồn khách",
          //   path: "customer-source-group",
          //   isVisible: true,
          // },
          {
            name: "Nguồn khách",
            path: "customer-source",
            isVisible: true,
          },
          {
            name: "Đối tượng khách hàng",
            path: "patient-type-service/1",
            isVisible: true,
          },
          {
            name: "Nhóm khách hàng",
            path: "patient-group",
            isVisible: true,
          },
          {
            name: "Phân loại khách hàng",
            path: "patient-type",
            isVisible: true,
          },
          {
            name: "Hạng khách hàng",
            path: "patient-rank",
            isVisible: true,
          },
          {
            name: "Hạng mục điểm",
            path: "client-award-type",
            isVisible: true,
          },
        ],
      },
      {
        name: "Trang thiết bị",
        isVisible: true,
        Icon: IconMedicalEquipment,
        children: [
          {
            name: "Loại trang thiết bị",
            path: "medical-equipment-type",
            isVisible: true,
          },
          {
            name: "Trang thiết bị chi tiết",
            path: "medical-equipment",
            isVisible: true,
          },
        ],
      },
      {
        name: "Đồng bộ kho",
        isVisible: true,
        Icon: IconDrug,
        children: [
          {
            name: "Sản phẩm",
            path: "drug",
            isVisible: true,
          },
          {
            name: "Vật tư y tế",
            path: "medical-supply",
            isVisible: true,
          },
          {
            name: "Đơn vị tính",
            path: "quantity-unit",
            isVisible: true,
          },
          {
            name: "Tồn kho",
            path: "inventory-reports-by-drug",
            isVisible: true,
          },
          {
            name: "Nhóm sản phẩm",
            path: "abstract-product",
            isVisible: true,
          },
          {
            name: "Cấu hình kho",
            path: "organizations",
            isVisible: true,
          },
        ],
      },
      {
        name: "Hình thức thanh toán",
        path: "payment-method",
        isVisible: true,
        Icon: IconMapMoney,
      },
      {
        name: "Quản lý kỳ hạn lãi suất",
        path: "interest-rate-period",
        isVisible: true,
        Icon: MonetizationOnIcon,
      },
      {
        name: "Loại giá",
        path: "patient-type-service/2",
        isVisible: true,
        Icon: MonetizationOnIcon,
      },
      {
        name: "Dân tộc",
        path: "ethnics",
        isVisible: true,
        Icon: IconEthnics,
      },
      {
        name: "Chức danh",
        path: "position",
        isVisible: true,
        Icon: IconProfession,
      },
      {
        name: "Thuế",
        path: "vat",
        isVisible: true,
        Icon: IconVat,
      },
      {
        name: "Chương trình khuyến mãi",
        path: "promotion-program",
        isVisible: true,
        Icon: LocalOfferIcon,
      },
      {
        name: "Khái niệm",
        path: "concept",
        isVisible: true,
        Icon: IconConcept,
      },
      // {
      //   name: "Danh mục dùng chung",
      //   path: "global-propoties",
      //   isVisible: true,
      //   Icon: IconUserEdit,
      // },
      {
        name: "Loại khoản thu chi",
        path: "revenue-expenditure",
        isVisible: true,
        Icon: EmojiEventsIcon,
      },
      {
        name: "Danh mục dùng chung",
        path: "global-propoties",
        isVisible: true,
        Icon: IconUserEdit,
      },
      {
        name: "Danh sách nhân viên",
        path: "staff-list",
        isVisible: true,
        Icon: IconStaff,
      },
      {
        name: "Phân quyền nhân viên",
        path: "permission-staff",
        isVisible: true,
        Icon: IconStaff,
      },
      {
        name: "Trạng thái nhân viên",
        path: "employee-status",
        isVisible: true,
        Icon: EmojiPeopleIcon,
      },
      {
        name: "Kỳ lương",
        path: "salary-period",
        isVisible: true,
        Icon: DateRangeIcon,
      },
      {
        name: "Nhóm nhân viên",
        path: "staff-group",
        isVisible: true,
        Icon: GroupIcon,
      },
      {
        name: "Loại check in",
        path: "visit-type",
        isVisible: true,
        Icon: EmojiEventsIcon,
      },
      {
        name: "Quản trị hệ thống",
        isVisible: true,
        Icon: SettingsIcon,
        children: [
          {
            name: "Tài khoản người dùng",
            path: "user-account",
            isVisible: true,
          },
          {
            name: "Lịch sử truy vết",
            path: "activity-log",
            isVisible: true,
          },
          {
            name: "Quản lý module",
            path: "module",
            isVisible: true,
          },
          {
            name: "Quản lý role",
            path: "role",
            isVisible: true,
          },
          {
            name: "Quản lý phân quyền",
            path: "permission",
            isVisible: true,
          },
          {
            name: "Quản lý menu",
            path: "menu",
            isVisible: true,
          },
          {
            name: "Đồng bộ hệ thống",
            path: "async-management",
            isVisible: true,
          },
          {
            name: "Thuộc tính hệ thống (Cấu hình)",
            path: "systemConfig",
            isVisible: true,
          },
        ],
      },
    ],
  },
  // {
  //   name: "Nhân sự",
  //   path: PathModule.STAFF,
  //   navigation: [
  //     // {
  //     //   name: "Danh sách nhân viên",
  //     //   path: "staff-list",
  //     //   isVisible: true,
  //     //   Icon: IconStaff,
  //     // },
  //     // {
  //     //   name: "Chấm công",
  //     //   path: "timekeeping",
  //     //   isVisible: true,
  //     //   Icon: IconVisitType,
  //     // },
  //     // {
  //     //   name: "Lịch hẹn khám",
  //     //   path: "appointment-schedule",
  //     //   isVisible: true,
  //     //   Icon: EventAvailableIcon,
  //     // },
  //     {
  //       name: "Lịch làm việc",
  //       path: "working-schedule",
  //       isVisible: true,
  //       Icon: IconSchedule,
  //     },
  //   ],
  // },
  {
    name: "Quản lý kho",
    path: PathModule.STORE,
    navigation: [
      {
        name: "Kho thuốc",
        path: "drug",
        isVisible: true,
        Icon: IconDrug,
      },
      {
        name: "Kho thiết bị y tế",
        path: "medical-equipment",
        isVisible: true,
        Icon: IconMedicalEquipment,
      },
      {
        name: "Kho vật tư y tế",
        path: "medical-supplies",
        isVisible: true,
        Icon: IconMedicalSupplies,
      },
    ],
  },
  {
    name: "Nội trú",
    path: PathModule.BOARDING,
    navigation: [
      {
        name: "DS chờ nhập viện",
        path: "waiting-list-patient",
        isVisible: true,
        Icon: IconWaitingPatient,
      },
      // {
      //   name: "Danh sách bệnh nhân",
      //   path: "patient-list",
      //   isVisible: true,
      //   Icon: IconServiceType,
      // },
      // {
      //   name: "Đợt điều trị",
      //   path: "treatment-regimen",
      //   isVisible: true,
      //   Icon: HealingIcon,
      // },
      // {
      //   name: "DS phiếu chờ tiếp nhận",
      //   path: "waiting-patient",
      //   isVisible: true,
      //   Icon: IconWaitingPatient,
      // },
      // {
      //   name: "DS phiếu đã tiếp nhận",
      //   path: "treating-patient",
      //   isVisible: true,
      //   Icon: IconTreatingPatient,
      // },
      // {
      //   name: "DS phiếu đã chuyển",
      //   path: "moved-patient",
      //   isVisible: true,
      //   Icon: IconMovedPatient,
      // },
      {
        name: "DS bệnh nhân nội trú",
        path: "inpatient-list",
        isVisible: true,
        Icon: PersonOutlineOutlinedIcon,
      },
      // {
      //   name: "Cấp phát thuốc",
      //   path: "drug-distribution",
      //   isVisible: true,
      //   Icon: IconDrug
      // },
      {
        name: "Yêu cầu lĩnh thuốc/vật tư",
        path: "store-request",
        isVisible: true,
        Icon: AssessmentIcon,
      },
      {
        name: "Tổng hợp yêu cầu lĩnh thuốc/vật tư",
        path: "medical-request-store",
        isVisible: true,
        Icon: IconDrug,
      },
      // {
      //   name: "Phiếu yêu cầu lĩnh thuốc",
      //   path: "drug-receipt-summary-individual",
      //   isVisible: true,
      //   Icon: AssessmentIcon,
      // },
      // {
      //   name: "Phiếu yêu cầu lĩnh thuốc tổng hợp",
      //   path: "drug-receipt-summary",
      //   isVisible: true,
      //   Icon: IconDrug,
      // },
      {
        name: "Ngày giường bệnh nhân",
        path: "patient-bed-date",
        isVisible: true,
        Icon: Timer,
      },
      {
        name: "Danh sách phẫu thuật",
        path: "await-approved-surgery",
        isVisible: true,
        Icon: AssignmentLate,
      },
      {
        name: "Báo cáo tồn kho theo thuốc",
        path: "inventory-reports-by-drug",
        isVisible: true,
        Icon: IconDrug,
      },
      {
        name: "Yêu cầu hoàn trả",
        path: "re-stock",
        isVisible: true,
        Icon: IconDrug,
      },
      // {
      //   name: "Sơ đồ giường bệnh",
      //   path: "bed-chart",
      //   isVisible: true,
      //   Icon: IconBedChart,
      // },
      // {
      //   name: "Điều trị nội trú",
      //   path: "inpatient-treatment",
      //   isVisible: true,
      //   Icon: IconInpatientTreatment
      // },
      // {
      //   name: "Quá trình điều trị",
      //   path: "treatment-process",
      //   isVisible: true,
      //   Icon: IconTreatmentProcess
      // }
    ],
  },
  {
    name: "Báo cáo",
    path: PathModule.REPORT,
    navigation: [
      {
        name: "Báo cáo TCKT",
        isVisible: !hasPaymentMethodLimits,
        Icon: IconWaitingPatient,
        children: [
          {
            name: "Báo cáo doanh thu KCB",
            path: "visit-invoice-patient",
            isVisible: !hasPaymentMethodLimits,
          },
          {
            name: "Báo cáo doanh thu nhà thuốc",
            path: "report-retail-requirements",
            isVisible: !hasPaymentMethodLimits,
          },
          // {
          //   name: "Báo cáo doanh thu",
          //   path: "visit-invoice-hi",
          //   isVisible: true,
          // },

          // {
          //   name: "DS viện phí theo BHYT",
          //   path: "visit-invoice-hi",
          //   isVisible: true,
          //   Icon: IconPayment
          // },
        ],
      },
      // {
      //   name: "Báo cáo quản lí chất lượng",
      //   isVisible: true,
      //   Icon: IconConcept,
      //   children: [
      //     // {
      //     //   name: "Báo cáo DVKT",
      //     //   path: "technical-services-report",
      //     //   isVisible: true,
      //     //   Icon: IconServiceType,
      //     // },
      //     {
      //       name: "Báo cáo dịch vụ",
      //       path: "service-report",
      //       isVisible: true,
      //       Icon: IconHealthCareService,
      //     },
      //   ],
      // },
      // {
      //   name: "Báo cáo nhân sự",
      //   isVisible: true,
      //   Icon: IconUserAccount,
      //   children: [
      //     {
      //       name: "Báo cáo DV theo nhân sự",
      //       path: "service-report-personal",
      //       isVisible: true,
      //       Icon: GroupIcon,
      //     },
      //   ],
      // },
      // {
      //   name: "Báo cáo điều dưỡng",
      //   isVisible: true,
      //   Icon: IconServiceRequestSet,
      //   children: [],
      // },

      {
        name: "Báo cáo KHTH",
        isVisible: !hasPaymentMethodLimits,
        Icon: IconPayment,
        children: [
          {
            name: "Báo cáo tạm ứng ngoại trú",
            path: "outpatient-advance-money",
            isVisible: !hasPaymentMethodLimits,
            Icon: IconPayment,
          },

          {
            name: "Báo cáo tạm ứng nội trú",
            path: "inpatient-advance-money",
            isVisible: !hasPaymentMethodLimits,
            Icon: IconPayment,
          },
          {
            name: "Báo cáo hoàn ứng ngoại trú",
            path: "outpatient-reimbursement",
            isVisible: !hasPaymentMethodLimits,
            Icon: IconPayment,
          },
          {
            name: "Báo cáo hoàn ứng nội trú",
            path: "inpatient-reimbursement",
            isVisible: !hasPaymentMethodLimits,
            Icon: IconPayment,
          },
          // {
          //   name: "Báo cáo bảo hiểm y tế",
          //   path: "health-reimbursement",
          //   isVisible: true,
          //   Icon: IconPayment,
          // },
        ],
      },
      {
        name: "Báo cáo tổ tiếp đón",
        isVisible: !hasPaymentMethodLimits,
        Icon: IconMedicalSupply,
        children: [
          {
            name: "Báo cáo khám theo dịch vụ",
            path: "patient-list",
            isVisible: !hasPaymentMethodLimits,
            Icon: PersonOutlineOutlinedIcon,
          },
          // {
          //   name: "Báo cáo BN hẹn khám",
          //   path: "appointment-report",
          //   isVisible: true,
          //   Icon: EventAvailableIcon,
          // },

          // {
          //   name: "Báo cáo tư vấn phẫu thuật",
          //   path: "surgical-cconsultation-report",
          //   isVisible: true,
          //   Icon: AssessmentIcon,
          // },
          // {
          //   name: "Báo cáo tiếp đón BN",
          //   path: "reception-report",
          //   isVisible: true,
          //   Icon: IconServiceType,
          // },
          // {
          //   name: "Báo cáo đăng kí khám",
          //   path: "registration-examination",
          //   isVisible: true,
          //   Icon: GroupIcon,
          // },
          {
            name: "Báo cáo thu chi",
            path: "income-expenditure",
            isVisible: !hasPaymentMethodLimits,
            Icon: PersonOutlineOutlinedIcon,
          },
          // {
          //   name: "Báo cáo thu chi tổng hợp",
          //   path: "consolidated-voucher",
          //   isVisible: true,
          //   Icon: PersonOutlineOutlinedIcon,
          // },
          // {
          //   name: "Báo cáo số lượt BN theo phòng",
          //   path: "report-service-request-item-by-room",
          //   isVisible: true,
          //   Icon: PersonOutlineOutlinedIcon,
          // },
          {
            name: "Báo cáo bệnh nhân theo phòng",
            path: "customer-to-room",
            isVisible: !hasPaymentMethodLimits,
            Icon: IconHospitalBed,
          },
          {
            name: "Báo cáo theo nguồn thuộc đợt điều trị",
            path: "customer-source-in-epi",
            isVisible: !hasPaymentMethodLimits,
            Icon: IconHospitalBed,
          },
          {
            name: "Báo cáo hoa hồng theo đối tượng",
            path: "commission-by-beneficiary-report",
            isVisible: !hasPaymentMethodLimits,
            Icon: EventAvailableIcon,
          },
          {
            name: "Báo cáo theo bác sĩ chỉ định",
            path: "revenue-by-assigner",
            isVisible: !hasPaymentMethodLimits,
            Icon: PersonOutlineOutlinedIcon,
          },
        ],
      },

      // ===================

      // {
      //   name: "Báo cáo doanh thu theo DV",
      //   path: "inpatient-reimbursement",
      //   isVisible: true,
      //   Icon: IconPayment
      // },

      // {
      //   name: "Phiếu dự trù thuốc",
      //   path: "estimate-drug",
      //   isVisible: true,
      //   Icon: IconDrug
      // },
      // {
      //   name: "Báo cáo dự trù thuốc",
      //   path: "estimate-drug-report",
      //   isVisible: true,
      //   Icon: IconDrug
      // },
      // {
      //   name: "Báo cáo dự trù vật tư y tế",
      //   path: "estimate-medical-supply-report",
      //   isVisible: true,
      //   Icon: IconMedicalSupplies
      // },
      {
        name: "Báo cáo 79,80A",
        path: "shi-report-7980",
        isVisible: !hasPaymentMethodLimits,
        Icon: IconServiceRequestSet,
      },
      {
        name: "Báo cáo hoạt động KCB",
        isVisible: !hasPaymentMethodLimits,
        Icon: IconWaitingPatient,
        children: [
          {
            name: "Báo cáo sử dụng dịch vụ",
            path: "report-service-by-group",
            isVisible: !hasPaymentMethodLimits,
          },
        ],
      },
      {
        name: "Báo cáo doanh thu theo đối tượng",
        path: "revenue-by-subject",
        isVisible: !hasPaymentMethodLimits,
        Icon: IconWaitingPatient,
      },
      // {
      //   name: "Báo cáo PTTT",
      //   isVisible: true,
      //   Icon: IconWaitingPatient,
      //   children: [
      //     {
      //       name: "Báo cáo chi phí PTTT",
      //       path: "cost-surgery-procedures",
      //       isVisible: true,
      //     },
      //     {
      //       name: "Báo cáo bệnh nhân phẫu thuật",
      //       path: "list-patient-procedures",
      //       isVisible: true,
      //     },
      //   ],
      // },
    ],
  },
  {
    name: "Chăm sóc khách hàng",
    path: PathModule.CUSTOMER_CARE,
    navigation: [
      // {
      //   name: "Danh sách khách đặt lịch",
      //   path: "booking-exam",
      //   isVisible: true,
      //   Icon: IconServiceType,
      // },
      {
        name: "navigation.receptionRoom.patientList",
        path: "patient-list",
        Icon: ListAltOutlined,
        isVisible: true,
      },
      {
        name: "navigation.receptionRoom.household",
        path: "family",
        isVisible: true,
        Icon: GroupAdd,
      },
      {
        name: "Khiếu nại",
        path: "customer-ticket",
        isVisible: true,
        Icon: ConfirmationNumber,
      },
    ],
  },
  {
    name: "Dashboard",
    path: PathModule.DASHBOARD,
    navigation: [
      {
        name: "Tổng quan",
        path: "overview",
        isVisible: true,
        Icon: IconWaitingPatient,
      },
      {
        name: "Tài chính",
        path: "revenue",
        isVisible: true,
        Icon: IconWaitingPatient,
      },
      // {
      //   name: "Số liệu bệnh viện",
      //   path: "hospital-data",
      //   isVisible: true,
      //   Icon: IconWaitingPatient,
      // },
      {
        name: "Thống kê danh sách bệnh nhân",
        path: "patient-list-statistics",
        isVisible: true,
        Icon: IconWaitingPatient,
      },
      {
        name: "Bệnh nhân theo tuổi và giới tính",
        path: "chart-statistics",
        isVisible: true,
        Icon: IconWaitingPatient,
      },
    ],
  },

  {
    name: "CRM",
    path: PathModule.MANAGEMENT_CRM,
    navigation: [{}],
  },

  {
    name: "module.accountant",
    path: PathModule.ACCOUNTANT,
    auth: [
      HIS_ADMIN,
      HIS_SALES_CONSULTANT,
      HIS_CASHIER,
      HIS_BRANCH_MANAGER,
      HIS_DOCTOR,
      HIS_CHIEF_TECHNICIAN,
      HIS_TECHNICIAN,
      HIS_ACCOUNTANT,
      HIS_READ_ONLY,
      HIS_TOUR_RECONCILIATION
    ],
    navigation: [
      {
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_CASHIER,
          HIS_ACCOUNTANT,
          HIS_READ_ONLY,
        ],
        name: "Báo cáo thu chi theo HTTT",
        path: "report-by-payment-method",
        isVisible: true,
        Icon: IconWaitingPatient,
      },

      // {
      //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      //   name: "Báo cáo khoản chi cơ sở",
      //   path: "report-expense",
      //   Icon: IconPayment,
      //   isVisible: true,
      // },
      {
        // auth: [
        //   HIS_ADMIN,
        //   HIS_BRANCH_MANAGER,
        //   HIS_CHIEF_TECHNICIAN,
        //   HIS_TECHNICIAN,
        //   HIS_CASHIER,
        //   HIS_READ_ONLY,
        // ],
        name: "Báo cáo phân bổ doanh thu theo nhân viên",
        path: "report-sales-allocation",
        Icon: Timer,
        isVisible: !hasPaymentMethodLimits,
      },
      // {
      //   auth: [
      //     HIS_ADMIN,
      //     HIS_BRANCH_MANAGER,
      //     HIS_CHIEF_TECHNICIAN,
      //     HIS_TECHNICIAN,
      //     HIS_CASHIER,
      //   ],
      //   name: "Báo cáo phân bổ doanh số theo nhân viên",
      //   path: "report-revenue-allocation",
      //   Icon: ListAltOutlined,
      //   isVisible: true,
      // },
      // {
      //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
      //   name: "Báo cáo công nợ",
      //   path: "report-debt",
      //   Icon: PersonOutlineOutlinedIcon,
      //   isVisible: true,
      // },
      // {
      //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      //   name: "Báo cáo doanh thu cũ mới",
      //   path: "voucher-item-report",
      //   Icon: PersonOutlineOutlinedIcon,
      //   isVisible: true,
      // },
      // {
      //   auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      //   name: "Báo cáo CheckIn",
      //   path: "report-checkin",
      //   Icon: IconServiceType,
      //   isVisible: true,
      // },
      {
        name: "Báo cáo điều trị",
        path: "treatment-report",
        Icon: IconDrug,
        isVisible: !hasPaymentMethodLimits,
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_CHIEF_TECHNICIAN,
          HIS_SUPER_ADMIN,
          HIS_DOCTOR,
          HIS_SALES_CONSULTANT,
          HIS_TECHNICIAN,
          HIS_CASHIER,
          HIS_ACCOUNTANT,
        ],
      },
      {
        auth: [
          HIS_ADMIN,
          HIS_BRANCH_MANAGER,
          HIS_CHIEF_TECHNICIAN,
          HIS_TECHNICIAN,
          HIS_CASHIER,
          HIS_ACCOUNTANT,
        ],
        name: "Báo cáo doanh thu chi tiết",
        path: "revenue-details-report",
        Icon: ListAltOutlined,
        isVisible: true,
      },
      {
        name: "Đối soát phân bổ doanh thu theo nhân viên",
        path: "staff-revenue-payment-revenue",
        Icon: IconMapMoney,
        isVisible: !hasPaymentMethodLimits,
        auth: [
          HIS_SUPER_ADMIN,
          HIS_ADMIN,
          HIS_ACCOUNTANT,
          // HIS_BRANCH_MANAGER,
          // HIS_CHIEF_TECHNICIAN,
          // HIS_DOCTOR,
          // HIS_SALES_CONSULTANT,
          // HIS_TECHNICIAN,
          // HIS_CASHIER,
        ],
      },
      // {
      //   name: "Đối soát phân bổ doanh số theo nhân viên",
      //   path: "staff-revenue-payment-sale",
      //   Icon: IconMapMoney,
      //   isVisible: true,
      //   auth: [
      //     HIS_SUPER_ADMIN,
      //     HIS_ADMIN,
      //     HIS_ACCOUNTANT,
      //     // HIS_BRANCH_MANAGER,
      //     // HIS_CHIEF_TECHNICIAN,
      //     // HIS_DOCTOR,
      //     // HIS_SALES_CONSULTANT,
      //     // HIS_TECHNICIAN,
      //     // HIS_CASHIER,
      //   ],
      // },
      {
        name: "Đối soát tiền tour",
        path: "check-suggest-fee",
        Icon: IconMapMoney,
        isVisible: !hasPaymentMethodLimits,
        auth: [
          HIS_SUPER_ADMIN,
          HIS_ADMIN,
          HIS_ACCOUNTANT,
          // HIS_BRANCH_MANAGER,
          // HIS_CHIEF_TECHNICIAN,
          // HIS_DOCTOR,
          // HIS_SALES_CONSULTANT,
          // HIS_TECHNICIAN,
          // HIS_CASHIER,
          HIS_TOUR_RECONCILIATION
        ],
      },
      {
        name: "Báo cáo phân bổ doanh thu theo nhân viên (tổng quát)",
        path: "report-employee-revenue-allocation-summary",
        Icon: BarChartIcon,
        isVisible: !hasPaymentMethodLimits,
        auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_ACCOUNTANT],
      },
      {
        name: "Tổng hợp doanh thu theo nhân viên",
        path: "revenue-summary-by-employee",
        Icon: BarChartIcon,
        isVisible: !hasPaymentMethodLimits,
        auth: [HIS_SUPER_ADMIN, HIS_ADMIN, HIS_ACCOUNTANT],
      },
      {
        name: "Báo cáo doanh thu chi tiết (nguồn)",
        path: "report-get-revenue-detail",
        Icon: AssessmentIcon,
        isVisible: !hasPaymentMethodLimits,
      },
    ],
  },
];

export const navigations = [
  {
    name: "navigation.userInformation",
    path: ConstantList.ROOT_PATH + "category/profile",
    isVisible: true,
  },
  {
    name: "Concept Type",
    path: ConstantList.ROOT_PATH + "category/concepttype",
    isVisible: true,
  },
  {
    name: "navigation.country",
    path: ConstantList.ROOT_PATH + "category/country",
    isVisible: true,
  },
  {
    name: "navigation.ethnics",
    path: ConstantList.ROOT_PATH + "category/ethnics",
    isVisible: true,
  },
  {
    name: "navigation.conceptAttributeType",
    path: ConstantList.ROOT_PATH + "category/conceptattributetype",

    isVisible: true,
  },
  {
    name: "navigation.conceptDataType",
    path: ConstantList.ROOT_PATH + "category/conceptdatatype",

    isVisible: true,
  },
  {
    name: "navigation.concept",
    path: ConstantList.ROOT_PATH + "category/concept",

    isVisible: true,
  },
];
